import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import {
    MsalGuardConfiguration,
    MsalInterceptorConfiguration, MSAL_GUARD_CONFIG, MSAL_INSTANCE,
    MSAL_INTERCEPTOR_CONFIG
} from '@azure/msal-angular';
import {
    BrowserCacheLocation, InteractionType, IPublicClientApplication,
    LogLevel, PublicClientApplication
} from '@azure/msal-browser';
import { AppModule } from './app/app.module';
//import { MSAL_CONFIG_ANGULAR, MSAL_CONFIG } from '@azure/msal-angular';
//import { Configuration } from 'msal';
import { nullSafe } from './app/utils';
import { environment } from './environments/environment';
import packageInfo from '../package.json';
import { Logger } from './app/utils/Logger';

//const isIE = true;//window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

function getApiBaseUrl(): string {
  return environment.apiBaseUrl;
}

function deleteBrowserStorage() {
  console.log('deleting browser storage');
  try {
    localStorage.clear();
  } catch (e) { }

  try {
    sessionStorage.clear()
  } catch (e) { }

  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    try {    
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    } catch (e) {}
  }
}

function getConfig(): Promise<any> {
  return new Promise((resolve, reject) => {
    const clientConfig = JSON.parse(localStorage.getItem('client_config'));
 
    if (
      clientConfig &&
      nullSafe(() => clientConfig.apiBaseUrl.length > 0, false) &&
      nullSafe(() => clientConfig.app_version == packageInfo.version, false)
    ) {
      resolve(clientConfig);
    } else {
      deleteBrowserStorage();
      fetch('/config')
        .then(res => {
          if (!res.ok) {
            throw new Error(`HTTP ${res.status} - ${res.statusText}`);
          }
          return res.json();
        })
        .then(cfg => {
          cfg.app_version = packageInfo.version;
          localStorage.setItem('client_config', JSON.stringify(cfg));
          resolve(cfg);
        })
        .catch(e => {
          console.error('Failed to load /config:', e);
          reject(e);
        });
    }
  });
}

// fetch('/config').then(res => res.json())
getConfig().then(async config => {
 environment.apiBaseUrl = config.apiBaseUrl;
 environment.azureAd.clientId = config.clientID;
 environment.azureAd.tenentId = config.tenentId;
 environment.azureAd.scopes = config.scopes;

 if (environment.production) {
 enableProdMode();
 }

 const origin = window.location.origin || `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;

 function loggerCallback(logLevel: LogLevel, message: string) {
 Logger.log('[msal]', message);
 }

 const msalInstance = new PublicClientApplication({
 auth: {
 clientId: environment.azureAd.clientId,
 authority: `https://login.microsoftonline.com/${environment.azureAd.tenentId}/`,
 redirectUri: `${origin}/signin-oidc`,
 postLogoutRedirectUri: `${origin}/logout`,
 navigateToLoginRequestUrl: false,
 },
 cache: {
 cacheLocation: BrowserCacheLocation.LocalStorage,
 storeAuthStateInCookie: false,
 },
 system: {
 loggerOptions: {
 loggerCallback,
 logLevel: LogLevel.Warning,
 piiLoggingEnabled: false
 }
 }
 });

 await msalInstance.initialize(); // ✅ Ensure MSAL is initialized before DI


 function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
 const protectedResourceMap = new Map<string, Array<string>>();
 protectedResourceMap.set(getApiBaseUrl(), environment.azureAd.scopes);
 protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);
 protectedResourceMap.set('https://graph.microsoft.com/v1.0/users', ['user.readbasic.all']);
 return {
 interactionType: InteractionType.Redirect,
 protectedResourceMap
 };
 }

 function MSALGuardConfigFactory(): MsalGuardConfiguration {
 return {
 interactionType: InteractionType.Redirect,
 authRequest: {
 scopes: [
 "user.read",
 "openid",
 "profile",
 ...environment.azureAd.scopes
 ],
 },
 loginFailedRoute: "/denied",
 };
 }
 platformBrowserDynamic([
 { provide: MSAL_INSTANCE, useValue: msalInstance },
 { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
 { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: MSALInterceptorConfigFactory }
 ])
 .bootstrapModule(AppModule)
 .catch(err => console.error(err));
});
